import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import BaseMui from './themes';
export default function BDSProvider(_a) {
    var children = _a.children, _b = _a.noCSSReset, noCSSReset = _b === void 0 ? false : _b, _c = _a.useBdsTheme, useBdsTheme = _c === void 0 ? true : _c;
    return (React.createElement(ThemeProvider, { theme: useBdsTheme ? BaseMui : {} },
        !noCSSReset ? React.createElement(CssBaseline, null) : null,
        children));
}
BDSProvider.propTypes = {
    children: PropTypes.node.isRequired
};
//# sourceMappingURL=BDSProvider.js.map